import { render, staticRenderFns } from "./RealmStory.vue?vue&type=template&id=1fbf7dbc"
import script from "./RealmStory.vue?vue&type=script&lang=js"
export * from "./RealmStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports